import { useEffect, useState } from "react";
import { GetRelatedArticles } from "../../../Api/Article";
import CountWrapper from "../../../Models/DTOs/CountWrapper";
import ArticleDTO from "../../../Models/DTOs/ArticleDTO";

export default function useFetchRelatedArticles(
    categoryId?: number,
    excludeId?: number,
    releasedBefore?: string,
    take: number = 5
) {
    const [relatedData, setRelatedData] = useState<CountWrapper<ArticleDTO> | null>(null);
    const [loadingRelated, setLoadingRelated] = useState(false);

    useEffect(() => {
        setRelatedData(null);
        setLoadingRelated(false);
        // Only fire if we actually have the required anchor data
        if (!categoryId || !excludeId || !releasedBefore) return;

        const controller = new AbortController();

        const fetchData = async () => {
            setLoadingRelated(true);
            try {
                const response = await GetRelatedArticles(
                    categoryId,
                    excludeId,
                    releasedBefore,
                    take,
                    controller
                );

                if (!controller.signal.aborted && response) {
                    setRelatedData(response);
                }
            } catch (err: any) {
                if (!controller.signal.aborted) {
                    console.error("Failed to fetch related articles:", err);
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoadingRelated(false);
                }
            }
        };

        fetchData();

        return () => controller.abort();
    }, [categoryId, excludeId, releasedBefore, take]);

    return { relatedData, loadingRelated };
}
